import { ApiPutRequest } from './api-put-request';
import { ApiParameters } from './api-parameters';
import { Order } from '../../interfaces/order';

export class UpdateOrderRequest extends ApiPutRequest
{
    public constructor(order: Order, webapiBasepath: string)
    {
        const parameters = new ApiParameters().addQueryParameter('orderid', order.Id);
        super('order', parameters, null, order, webapiBasepath);
    }
}
